import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import "./ui/globals.css";
import "./ui/motion.css";
import App from "./App";
import { AuthProvider } from "./auth/AuthContext";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </StrictMode>,
);
